exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-48868bb9] {\n  position: fixed;\n  top: 30px;\n  left: 15px;\n  width: calc(100% - 30px);\n}\n", ""]);

// exports
